import { useTranslation } from "react-i18next";
import React from "react";
import { useForm } from "react-hook-form";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import toast from "react-hot-toast";
import {
  FaArrowRight,
  FaIdCard,
  FaRoute,
  FaSearch,
  FaShieldAlt,
} from "react-icons/fa";
import AuthNavBar from "./components/nav/AuthNav";
import { fetchUserBySin, fetchUserByNui, userSelector } from "./User/UserSlice";
import "./TrackEnrolment.css";

const TrackEnrolment = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const history = useHistory();
  const { isFetching } = useSelector(userSelector);
  const {
    register: registerTrackingId,
    handleSubmit: submitTrackingId,
    errors: trackingIdErrors,
  } = useForm();
  const {
    register: registerNui,
    handleSubmit: submitNui,
    errors: nuiErrors,
  } = useForm();

  const onSubmitTrackingId = async (data) => {
    const resultAction = await dispatch(fetchUserBySin(data));

    if (
      fetchUserBySin.fulfilled.match(resultAction) &&
      resultAction.payload?.firstName
    ) {
      history.push("/profile");
      return;
    }

    toast.error(t("tracking_id_not_found"));
  };

  const onSubmitNui = async (data) => {
    const resultAction = await dispatch(fetchUserByNui(data));

    if (
      fetchUserByNui.fulfilled.match(resultAction) &&
      resultAction.payload?.firstName
    ) {
      history.push("/profile2");
      return;
    }

    toast.error(t("nui_not_found"));
  };

  return (
    <div className="track-page">
      <AuthNavBar />
      <main className="track-main">
        <section className="track-hero" aria-labelledby="track-heading">
          <div>
            <div className="track-eyebrow">
              <span /> {t("application_tracking_header")}
            </div>
            <h1 id="track-heading">{t("find_enrollment_status")}</h1>
            <p>
              {t("use_reference_received")}
            </p>
          </div>
          <FaRoute className="track-hero-icon" aria-hidden="true" />
        </section>

        <section
          className="track-searches"
          aria-label="Enrollment search options"
        >
          <article className="track-search-card primary-search">
            <div className="search-card-icon green">
              <FaSearch />
            </div>
            <div className="search-card-heading">
              <span>{t("recommended")}</span>
              <h2>{t("search_by_tracking_id")}</h2>
              <p>
                {t("enter_tracking_id_issued")}
              </p>
            </div>
            <form onSubmit={submitTrackingId(onSubmitTrackingId)} noValidate>
              <label htmlFor="tracking-id">{t("tracking_id_label")}</label>
              <div className="track-input">
                <FaRoute aria-hidden="true" />
                <input
                  id="tracking-id"
                  name="trackingId"
                  placeholder={t("enter_your_tracking_id")}
                  autoComplete="off"
                  ref={registerTrackingId({
                    required: t("tracking_id_required"),
                  })}
                />
              </div>
              {trackingIdErrors.trackingId && (
                <p className="track-error" role="alert">
                  {trackingIdErrors.trackingId.message}
                </p>
              )}
              <button
                type="submit"
                disabled={isFetching}
                aria-busy={isFetching}
              >
                {isFetching ? (
                  <>
                    <span className="track-spinner" /> {t("searching")}
                  </>
                ) : (
                  <>
                    {t("track_enrollment_btn")} <FaArrowRight />
                  </>
                )}
              </button>
            </form>
          </article>

          <article className="track-search-card">
            <div className="search-card-icon blue">
              <FaIdCard />
            </div>
            <div className="search-card-heading">
              <span>{t("alternative_lookup")}</span>
              <h2>{t("search_by_nui")}</h2>
              <p>
                {t("use_nui_view")}
              </p>
            </div>
            <form onSubmit={submitNui(onSubmitNui)} noValidate>
              <label htmlFor="nui">{t("nui_label")}</label>
              <div className="track-input">
                <FaIdCard aria-hidden="true" />
                <input
                  id="nui"
                  name="nui"
                  placeholder={t("enter_your_nui")}
                  autoComplete="off"
                  ref={registerNui({ required: t("nui_required") })}
                />
              </div>
              {nuiErrors.nui && (
                <p className="track-error" role="alert">
                  {nuiErrors.nui.message}
                </p>
              )}
              <button
                type="submit"
                disabled={isFetching}
                aria-busy={isFetching}
              >
                {isFetching ? (
                  <>
                    <span className="track-spinner" /> {t("searching")}
                  </>
                ) : (
                  <>
                    {t("find_my_record")} <FaArrowRight />
                  </>
                )}
              </button>
            </form>
          </article>
        </section>

        <section
          className="track-security-note"
          aria-label="Secure tracking notice"
        >
          <FaShieldAlt aria-hidden="true" />
          <div>
            <strong>{t("enrollment_info_protected")}</strong>
            <p>
              {t("only_enter_own_id")}
            </p>
          </div>
        </section>
      </main>
    </div>
  );
};

export default TrackEnrolment;
